import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  CircularProgress,
} from '@material-ui/core';
import { MDButton } from '../../../components/MDButton';
import { MDTypography } from '../../../components/MDTypography';

interface MoveBillDialogProps {
  open: boolean;
  billId: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const MoveBillDialog: React.FC<MoveBillDialogProps> = ({
  open,
  billId,
  onConfirm,
  onCancel,
  loading = false,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="move-bill-dialog-title"
      aria-describedby="move-bill-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="move-bill-dialog-title">
        {t('Move Bill to Next Payment')}
      </DialogTitle>

      <DialogContent>
        <>
          <MDTypography variant="body1" gutterBottom>
            {t(
              'Are you sure you want to move this bill to the next payment request?'
            )}
          </MDTypography>

          <MDTypography variant="body2" color="secondary" gutterBottom>
            <strong>{t('Bill ID')}:</strong> {billId}
          </MDTypography>

          <MDTypography
            variant="body2"
            color="warning"
            style={{ marginTop: '16px' }}
          >
            {t(
              'This action will remove the bill from the current payment request and it will be included in the next payment cycle.'
            )}
          </MDTypography>
        </>
      </DialogContent>

      <DialogActions>
        <MDButton
          onClick={onCancel}
          color="secondary"
          variant="outlined"
          disabled={loading}
        >
          {t('Cancel')}
        </MDButton>

        <MDButton
          onClick={onConfirm}
          color="warning"
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={18} /> : null}
        >
          {loading ? t('Moving...') : t('Yes, Move Bill')}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

export default MoveBillDialog;
